import React, { FC, useState, useEffect } from 'react';

import { useLocation } from 'views/services/location-context';
import Image from './views/image';
import LinkedImage from './views/linked-image';

interface Props {
  page: string;
  name: string;
  normalImage: string;
  hoverImage: string;
  activeImage: string;
}

const AbstractMenuItem: FC<Props> = ({ page, name, normalImage, hoverImage, activeImage }) => {

  const [isCurrentPage, setIsCurrentPage] = useState(false);
  const location = useLocation();
  const image = <Image src={activeImage} alt={name} />;
  const linkedImage = <LinkedImage to={page} src={normalImage} alt={name} hoverImage={hoverImage} />;

  function watchLocation() {
    if (!location) return;
    setIsCurrentPage(page === location.pathname);
  }

  useEffect(watchLocation, [location?.pathname]);

  return isCurrentPage ? image : linkedImage;
};

export default AbstractMenuItem;
